import { render, staticRenderFns } from "./SpecialStopCardPop.vue?vue&type=template&id=50a54005&scoped=true&"
import script from "./SpecialStopCardPop.vue?vue&type=script&lang=js&"
export * from "./SpecialStopCardPop.vue?vue&type=script&lang=js&"
import style0 from "./SpecialStopCardPop.vue?vue&type=style&index=0&id=50a54005&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a54005",
  null
  
)

export default component.exports